import api from "../utils/axios/axiosConfig";

const leadsService = {
  create: (data) => api.post("/leads/create", data),
  update: (id, data) => api.put(`/leads/update/${id}`, data),
  delete: (id) => api.delete(`/leads/delete/${id}`),
  get: (id) => api.get(`/leads/get/${id}`),
  search: (params) => api.post("/leads/search", params),
  convert: (leadId, data) => api.post(`/leads/convert/${leadId}`, data),
  unreadCount: () => api.get("/leads/unread-count"),
  markAsRead: (id) => api.patch(`/leads/mark-as-read/${id}`),
  markAsUnread: (id) => api.patch(`/leads/mark-as-unread/${id}`),
  markManyAsRead: (ids) => api.patch("/leads/mark-many-as-read", { ids }),
  markAllAsRead: () => api.patch("/leads/mark-all-as-read"),
  updateStatus: (id, data) => api.patch(`/leads/update-status/${id}`, data),
};

export default leadsService;
